import { CertificationType } from 'src/common/enums/certification';

import type { CertificationConfigProps } from '../header.types';

export const CERTIFICATION_CONFIGS: CertificationConfigProps[] = [
  {
    type: CertificationType.PT1,
    basePath: '/certification/junior-penetration-tester',
    name: 'PT1',
    description: 'Jr Penetration Tester Certificate',
  },
  {
    type: CertificationType.SAL1,
    basePath: '/certification/security-analyst-level-1',
    name: 'SAL1',
    description: 'Security Analyst Level 1 Certificate',
  },
];
